/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EquipmentResponse } from './EquipmentResponse';
import {
    EquipmentResponseFromJSON,
    EquipmentResponseFromJSONTyped,
    EquipmentResponseToJSON,
    EquipmentResponseToJSONTyped,
} from './EquipmentResponse';
import type { UndercarriageChangeOutSyncResponse } from './UndercarriageChangeOutSyncResponse';
import {
    UndercarriageChangeOutSyncResponseFromJSON,
    UndercarriageChangeOutSyncResponseFromJSONTyped,
    UndercarriageChangeOutSyncResponseToJSON,
    UndercarriageChangeOutSyncResponseToJSONTyped,
} from './UndercarriageChangeOutSyncResponse';
import type { AssetManufacturerResponse } from './AssetManufacturerResponse';
import {
    AssetManufacturerResponseFromJSON,
    AssetManufacturerResponseFromJSONTyped,
    AssetManufacturerResponseToJSON,
    AssetManufacturerResponseToJSONTyped,
} from './AssetManufacturerResponse';
import type { AssetModelResponse } from './AssetModelResponse';
import {
    AssetModelResponseFromJSON,
    AssetModelResponseFromJSONTyped,
    AssetModelResponseToJSON,
    AssetModelResponseToJSONTyped,
} from './AssetModelResponse';
import type { MineLocationResponse } from './MineLocationResponse';
import {
    MineLocationResponseFromJSON,
    MineLocationResponseFromJSONTyped,
    MineLocationResponseToJSON,
    MineLocationResponseToJSONTyped,
} from './MineLocationResponse';
import type { AssetTypeResponse } from './AssetTypeResponse';
import {
    AssetTypeResponseFromJSON,
    AssetTypeResponseFromJSONTyped,
    AssetTypeResponseToJSON,
    AssetTypeResponseToJSONTyped,
} from './AssetTypeResponse';
import type { SiteResponse } from './SiteResponse';
import {
    SiteResponseFromJSON,
    SiteResponseFromJSONTyped,
    SiteResponseToJSON,
    SiteResponseToJSONTyped,
} from './SiteResponse';
import type { AssetResponse } from './AssetResponse';
import {
    AssetResponseFromJSON,
    AssetResponseFromJSONTyped,
    AssetResponseToJSON,
    AssetResponseToJSONTyped,
} from './AssetResponse';
import type { CustomerResponse } from './CustomerResponse';
import {
    CustomerResponseFromJSON,
    CustomerResponseFromJSONTyped,
    CustomerResponseToJSON,
    CustomerResponseToJSONTyped,
} from './CustomerResponse';

/**
 * 
 * @export
 * @interface FleetSyncItemsResponse
 */
export interface FleetSyncItemsResponse {
    /**
     * 
     * @type {Array<AssetResponse>}
     * @memberof FleetSyncItemsResponse
     */
    assets?: Array<AssetResponse>;
    /**
     * 
     * @type {Array<AssetManufacturerResponse>}
     * @memberof FleetSyncItemsResponse
     */
    assetManufacturers?: Array<AssetManufacturerResponse>;
    /**
     * 
     * @type {Array<AssetModelResponse>}
     * @memberof FleetSyncItemsResponse
     */
    assetModels?: Array<AssetModelResponse>;
    /**
     * 
     * @type {Array<AssetTypeResponse>}
     * @memberof FleetSyncItemsResponse
     */
    assetTypes?: Array<AssetTypeResponse>;
    /**
     * 
     * @type {Array<CustomerResponse>}
     * @memberof FleetSyncItemsResponse
     */
    customers?: Array<CustomerResponse>;
    /**
     * 
     * @type {Array<SiteResponse>}
     * @memberof FleetSyncItemsResponse
     */
    sites?: Array<SiteResponse>;
    /**
     * 
     * @type {Array<MineLocationResponse>}
     * @memberof FleetSyncItemsResponse
     */
    mineLocations?: Array<MineLocationResponse>;
    /**
     * 
     * @type {Array<EquipmentResponse>}
     * @memberof FleetSyncItemsResponse
     */
    equipments?: Array<EquipmentResponse>;
    /**
     * 
     * @type {Array<UndercarriageChangeOutSyncResponse>}
     * @memberof FleetSyncItemsResponse
     */
    undercarriageChangeOuts?: Array<UndercarriageChangeOutSyncResponse>;
}

/**
 * Check if a given object implements the FleetSyncItemsResponse interface.
 */
export function instanceOfFleetSyncItemsResponse(value: object): value is FleetSyncItemsResponse {
    return true;
}

export function FleetSyncItemsResponseFromJSON(json: any): FleetSyncItemsResponse {
    return FleetSyncItemsResponseFromJSONTyped(json, false);
}

export function FleetSyncItemsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetSyncItemsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assets': json['assets'] == null ? undefined : ((json['assets'] as Array<any>).map(AssetResponseFromJSON)),
        'assetManufacturers': json['assetManufacturers'] == null ? undefined : ((json['assetManufacturers'] as Array<any>).map(AssetManufacturerResponseFromJSON)),
        'assetModels': json['assetModels'] == null ? undefined : ((json['assetModels'] as Array<any>).map(AssetModelResponseFromJSON)),
        'assetTypes': json['assetTypes'] == null ? undefined : ((json['assetTypes'] as Array<any>).map(AssetTypeResponseFromJSON)),
        'customers': json['customers'] == null ? undefined : ((json['customers'] as Array<any>).map(CustomerResponseFromJSON)),
        'sites': json['sites'] == null ? undefined : ((json['sites'] as Array<any>).map(SiteResponseFromJSON)),
        'mineLocations': json['mineLocations'] == null ? undefined : ((json['mineLocations'] as Array<any>).map(MineLocationResponseFromJSON)),
        'equipments': json['equipments'] == null ? undefined : ((json['equipments'] as Array<any>).map(EquipmentResponseFromJSON)),
        'undercarriageChangeOuts': json['undercarriageChangeOuts'] == null ? undefined : ((json['undercarriageChangeOuts'] as Array<any>).map(UndercarriageChangeOutSyncResponseFromJSON)),
    };
}

export function FleetSyncItemsResponseToJSON(json: any): FleetSyncItemsResponse {
    return FleetSyncItemsResponseToJSONTyped(json, false);
}

export function FleetSyncItemsResponseToJSONTyped(value?: FleetSyncItemsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assets': value['assets'] == null ? undefined : ((value['assets'] as Array<any>).map(AssetResponseToJSON)),
        'assetManufacturers': value['assetManufacturers'] == null ? undefined : ((value['assetManufacturers'] as Array<any>).map(AssetManufacturerResponseToJSON)),
        'assetModels': value['assetModels'] == null ? undefined : ((value['assetModels'] as Array<any>).map(AssetModelResponseToJSON)),
        'assetTypes': value['assetTypes'] == null ? undefined : ((value['assetTypes'] as Array<any>).map(AssetTypeResponseToJSON)),
        'customers': value['customers'] == null ? undefined : ((value['customers'] as Array<any>).map(CustomerResponseToJSON)),
        'sites': value['sites'] == null ? undefined : ((value['sites'] as Array<any>).map(SiteResponseToJSON)),
        'mineLocations': value['mineLocations'] == null ? undefined : ((value['mineLocations'] as Array<any>).map(MineLocationResponseToJSON)),
        'equipments': value['equipments'] == null ? undefined : ((value['equipments'] as Array<any>).map(EquipmentResponseToJSON)),
        'undercarriageChangeOuts': value['undercarriageChangeOuts'] == null ? undefined : ((value['undercarriageChangeOuts'] as Array<any>).map(UndercarriageChangeOutSyncResponseToJSON)),
    };
}

